// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7p-0";
export var startPickingButton = "_7p-1";